import EngagementSurveyReportFilterContainer from "@apps/reporting/components/engagement-survey-report/engagement-survey-report-filter-container";
import { EngagementSurveyReportFilterItem } from "@apps/reporting/components/engagement-survey-report/types";
import ViewOptionsSidebar from "@apps/reporting/components/sidebar/view-options-sidebar";

const EngagementSurveyDeliveryFilterSidebar = ({
  filters,
  onUpdateFilters,
  onClose,
}: {
  filters: EngagementSurveyReportFilterItem[];
  onUpdateFilters: (filters: EngagementSurveyReportFilterItem[]) => void;
  onClose: () => void;
}) => {
  return (
    <ViewOptionsSidebar onClose={onClose}>
      <div className="border-t p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="font-semibold">Filters</div>
        </div>
        <div>
          <EngagementSurveyReportFilterContainer
            filters={filters}
            onUpdateFilters={onUpdateFilters}
          />
        </div>
      </div>
    </ViewOptionsSidebar>
  );
};

export default EngagementSurveyDeliveryFilterSidebar;
